import {
  createCheckAuthorization,
  resolveAuthState,
  splitByScope,
  validateReverificationConfig
} from "./chunk-3CN5LOSN.mjs";
import "./chunk-7ELT755Q.mjs";
export {
  createCheckAuthorization,
  resolveAuthState,
  splitByScope,
  validateReverificationConfig
};
//# sourceMappingURL=authorization.mjs.map